import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppState } from 'store';
import controlInitAction from 'modules/controlInit/controlInit.action';
import { controlInitModule } from 'modules/controlInit/controlInit.reducer';
import AdmControlInitDetail from './AdmControlInitDetail';

const AdmControlInitDetailContainer = () => {
  const dispatch = useDispatch();
  const controlInitState = useSelector((state: AppState) => state.pages.controlInit);
  const { currentGroup } = useSelector((state: AppState) => state.pages.groupsClass);
  const { id } = useParams<{ id: string }>();
  const uploadFileControlInit = (file: FormData) => {
    dispatch(controlInitAction.uploadControlInitFile(file));
  };

  const createControlInit = (data: { name?: string; fname?: string; groupId: number }) => {
    dispatch(controlInitAction.createControlInit(data));
  };
  const updateControlInit = (data: { ctrRsId: number; name?: string; fname?: string; groupId: number }) => {
    dispatch(controlInitAction.updateControlInit(data));
  };
  const getDetailControlInit = (data: { ctrRsId: number; groupId: number }) => {
    dispatch(controlInitAction.getControlInitDetail(data));
  };

  const updateDataFileUpload = () => {
    dispatch(controlInitModule.actions.setDataFileUpload({}));
  };
  return (
    <AdmControlInitDetail
      id={id}
      currentGroup={currentGroup}
      controlInitState={controlInitState}
      createControlInit={createControlInit}
      getDetailControlInit={getDetailControlInit}
      updateControlInit={updateControlInit}
      uploadFileControlInit={uploadFileControlInit}
      updateDataFileUpload={updateDataFileUpload}
    />
  );
};

export default AdmControlInitDetailContainer;
